import { render } from "./full_image.vue?vue&type=template&id=5b4fa2dd"
import script from "./full_image.vue?vue&type=script&lang=js"
export * from "./full_image.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__